import { REGISTERS_API_URL } from '../constants';
import type { AppDatabase } from '../db';
import type { Modifier } from '../models';
import { MAX_FETCH_PROGRESS, retrieveFullPaginatedData } from '../pagination';
import { toBooleanValueFields } from '../transform';
import type { MappedModifierResponse } from '../types';

export class ModifierService {
    constructor(private readonly db: AppDatabase) {
        this.db = db;
    }

    async fetchAndBulkUpsert(
        lastSyncTime?: string,
        progressCallback?: (progress: number, nextPage?: number) => void,
    ) {
        const params = {
            timestamp: lastSyncTime ?? null,
            isActive: lastSyncTime ? null : true,
        };

        await retrieveFullPaginatedData<MappedModifierResponse>(
            REGISTERS_API_URL.PRODUCT.MODIFIERS,
            params,
            async (data, progress) => {
                progressCallback?.(progress);
                await this.bulkUpsert(data);
            },
        );

        progressCallback?.(MAX_FETCH_PROGRESS);
    }

    async bulkUpsert(groups: MappedModifierResponse[]) {
        const output = groups.map((group) => {
            return toBooleanValueFields(group, ['deleted', 'active']);
        });

        await this.db.modifiers.bulkPut(output as unknown as Modifier[]);
    }

    async getByIds(modifierIds: string[]): Promise<Modifier[]> {
        if (!modifierIds.length) return [];

        return this.db.modifiers.where('id').anyOf(modifierIds).toArray();
    }
}
